enum RouteName {
  HomeRedirect = 'home-redirect',
  NotFound = 'not-found',
  Preferences = 'preferences',
  Unsubscribe = 'unsubscribe',
}

export default RouteName;
